import {
  type OfferV11,
  OfferV1NowProductGroupEnum,
} from '@redteclab/api/clients/bully'

export const productAccessorGetDoesSupportNow = (offer: OfferV11): boolean => {
  if (!offer.nowProductGroup) {
    return false
  }

  return offer.nowProductGroup !== OfferV1NowProductGroupEnum.None
}
